import React, { useEffect, useRef } from 'react';

interface Props {
    onKeyDown: (event: KeyboardEvent) => void;
    children: React.ReactNode;
}

export const KeyboardShortcutHandler: React.FC<Props> = props => {
    const onKeyDownHandlersRef = useRef<((event: KeyboardEvent) => void)[]>([]);

    const onKeyDown = (e: KeyboardEvent & { detail?: { keyCode?: number } }) => {
        const event = e;

        // propagate detail information into event
        if (!event.keyCode && event.detail) {
            // @ts-expect-error FIXME: Attempt to assign to const or readonly variable
            event.keyCode = event.detail.keyCode;
        }

        onKeyDownHandlersRef.current.forEach(handler => {
            if (typeof handler === 'function') {
                handler(event);
            }

            if (event.defaultPrevented || !event.bubbles) {
                return false; // break in forEach
            }
        });
    };

    const addEventListener = () => {
        onKeyDownHandlersRef.current.push(props.onKeyDown);
        document.removeEventListener('keydown', onKeyDown);
        document.addEventListener('keydown', onKeyDown);
        window.addEventListener('unload', removeEventListener);
    };

    const removeEventListener = () => {
        onKeyDownHandlersRef.current = onKeyDownHandlersRef.current.filter(f => f !== props.onKeyDown);
    };

    useEffect(() => {
        addEventListener();
        return removeEventListener; // will be called at unmount
    }, []);

    return <>{props.children}</>;
};

export default KeyboardShortcutHandler;
